"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var FormatData = _interopRequireWildcard(require("../../utils/normalizeFormat"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useFormatRooms = (value, formatType, options) => {
  const [currentValue, setCurrentValue] = (0, _react.useState)(value);
  (0, _react.useEffect)(() => {
    let thisValue = value;
    if (formatType && formatType.includes('rooms')) {
      if (formatType.split('-')[0] === 'rooms' && typeof value === 'number') {
        thisValue = FormatData.formatRooms(value);
      }
    } else {
      thisValue = value;
    }
    setCurrentValue(thisValue);
  }, [value, formatType, options]);
  return currentValue;
};
var _default = exports.default = useFormatRooms;